module.exports = __webpack_public_path__ + "img/bill.415971d8.jpg";